import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const usePhases = () => {
  const cubeCtx = useCubeContext()

  return {
    orderedPhases: cubeCtx.queries.orderedPhases,
    resolvedPhases: cubeCtx.queries.resolvedPhases,
    rawPhases: cubeCtx.queries.rawData.data.common.phaseIds.map(
      phaseId => cubeCtx.queries.rawData.data.phases[phaseId]
    )
  }
}
